import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	signIn: {
		id: 'projects-directory-v3.page-layout.no-permission-views.no-permissions.sign-in-redirect.sign-in',
		defaultMessage:
			"<link>Try logging in.</link> If you're already logged in, ask a Jira admin to change your permissions.",
		description: 'Instructions for the user on how to obtain access',
	},
});
